import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { TemperatureLogger } from '../../../types/typescript-axios'
import { TabContainer } from '../../../components/part/tab-container'
import { NoPaddingLayoutWithTitle } from '../../../components/templates/no-padding-layout-with-title'
import { Lang } from '../../../translations/lang'
import { webRequest } from '../../../types/handle-api'
import { ReusableOrderHistory } from '../../../components/templates/transactions/reusable-order-history'
import { BelongingLogHistory } from '../../../components/templates/transactions/belonging-log-history'
import { ShippingStateLogHistory } from '../../../components/templates/transactions/shipping-state-log-history'
import { ProductNoteHistory } from '../../../components/templates/transactions/product-note-history'
import { QRCodeSVG } from 'qrcode.react'

export const AdminTemperatureLoggerDetail = () => {
  const { id } = useParams<{ id: string }>()
  const [temperatureLogger, setTemperatureLogger] =
    useState<TemperatureLogger>()

  useEffect(() => {
    async function fetchData() {
      const response = await webRequest('TemperatureLoggersShow', {
        id: Number(id),
      })
      if (response.status === 200) {
        setTemperatureLogger(response.data.temperatureLogger)
      }
    }

    fetchData()
  }, [id])

  return (
    <NoPaddingLayoutWithTitle
      title={Lang.admin.temperatureLoggerDetail.title}
      link={{
        label: Lang.admin.temperatureLoggerDetail.goBackToInspectionBoards,
        link: '/temperature-loggers',
      }}
    >
      <div className="flex container mt-16 mb-40 gap-16">
        <div>
          <label>{Lang.temperatureLoggerSerialNo}</label>
          <p className="mt-12 text-lg font-bold">
            {temperatureLogger?.serialNo}
          </p>
        </div>
        <div>
          <label>{Lang.model}</label>
          <p className="mt-12 text-lg font-bold">{temperatureLogger?.model}</p>
        </div>

        {temperatureLogger?.serialNo && (
          <QRCodeSVG
            value={`${temperatureLogger?.model}_${temperatureLogger?.serialNo}`}
            size={90}
          />
        )}
      </div>

      <TabContainer
        tabs={[
          {
            tabName: Lang.tradeHistory,
            element: (
              <ShippingStateLogHistory productType="TEMPERATURE_LOGGER" />
            ),
          },
          {
            tabName: Lang.transitionHistory,
            element: <BelongingLogHistory productType="TEMPERATURE_LOGGER" />,
          },
          {
            tabName: Lang.reusableOrderHistory,
            element: <ReusableOrderHistory productType="TEMPERATURE_LOGGER" />,
          },
          {
            tabName: Lang.notesHistory,
            element: <ProductNoteHistory productType="TEMPERATURE_LOGGER" />,
          },
        ]}
      />
    </NoPaddingLayoutWithTitle>
  )
}
